import { Link } from "react-router-dom"
import React from "react"

export default function ExploreProductCard(props) {
  const imageUrl = require(`../../assets/category/${props.image}`)
  return (
    <div className="explore-product-card border-box bg-white">
      <Link className="link" to={props.link}>
        <div className="explore-product-image">
          <img
            src={imageUrl}
            alt="product category image"
          />
        </div>
        <h4>{props.name}</h4>
        {/*  */}
      </Link>
    </div>
  )
}
